import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/checkout';
import { PRODUCT_NAME } from '../data/brand';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  /** 'offer' scrolls to #offer-details, 'checkout' opens the payment page. */
  target?: 'offer' | 'checkout';
  size?: 'md' | 'lg';
  fullWidth?: boolean;
}
export const OFFER_ID = 'offer-details';
export function CtaButton({
  children,
  target = 'offer',
  size = 'lg',
  fullWidth = false
}: CtaButtonProps) {
  const isCheckout = target === 'checkout';
  // InitiateCheckout is fired by the checkout page itself on load — only ViewContent is tracked here.
  const handleClick = isCheckout ? undefined : (event: React.MouseEvent<HTMLAnchorElement>) => {
    trackPixelEvent('ViewContent', {
      content_name: `${PRODUCT_NAME} — Kompletny pakiet`,
      value: 35,
      currency: 'USD'
    });
    const offer = document.getElementById(OFFER_ID);
    if (!offer) return;
    event.preventDefault();
    scrollToOffer(offer);
  };
  return <a href={isCheckout ? CHECKOUT_URL : `#${OFFER_ID}`} onClick={handleClick} className={`group inline-flex items-center justify-center gap-2.5 rounded-xl bg-btn text-center font-bold uppercase leading-tight tracking-[0.02em] text-white shadow-btn transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-btn-hover active:translate-y-1 active:shadow-btn-press ${size === 'lg' ? 'px-6 py-4 text-base sm:px-8 sm:py-5 sm:text-xl' : 'px-5 py-3 text-sm'} ${fullWidth ? 'w-full' : ''}`} data-id="element-28" data-mp="39z9ld57bvr5p">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-29" data-mp="6ikbpacg81bt" />
    </a>;
}

/**
 * Scrolls to the offer and re-checks after images above it have loaded,
 * so late layout shifts can't leave the visitor on another section.
 */
function scrollToOffer(offer: HTMLElement) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  offer.scrollIntoView({
    behavior: reduceMotion ? 'auto' : 'smooth',
    block: 'start'
  });
  const correct = () => {
    if (Math.abs(offer.getBoundingClientRect().top) > 40) {
      offer.scrollIntoView({
        behavior: 'auto',
        block: 'start'
      });
    }
  };
  window.setTimeout(correct, 700);
  window.setTimeout(correct, 1400);
}